module.exports = __webpack_public_path__ + "img/omega.07b4127a.png";